<template>
  <div class="infor-geral-molde">
    <div class="categorias">Informações Gerais do Molde</div>
    <div>
      <div class="items">
        <div class="bd-right">
          <div class="item-title">Dimensões (mm) C x L x A</div>
          <div class="row">
            <div>{{ dataMoldeFechado.COMPRIMENTO_MOLDE }}</div>
            <div>{{ dataMoldeFechado.LARGURA_MOLDE }}</div>
            <div>{{ dataMoldeFechado.ALTURA_MOLDE }}</div>
          </div>
        </div>

        <div class="bd-right">
          <div class="item-title">Peso (Kg)</div>
          <div>{{ dataMoldeFechado.PESO_MOLDE }}</div>
        </div>

        <div>
          <div class="item-title">Anel de Centragem (mm)</div>
          <div>{{ dataMoldeFechado.ANEL_CENTRAGEM }}</div>
        </div>
      </div>
      <div class="items bd-top">
        <div class="bd-right">
          <div class="item-title">Formato da Bucha</div>
          <div class="row">
            <!-- <div class="item-title">Furo</div>
            <div>{{ dataMoldeFechado[0].BUCHA_DE_INJECAO }}</div> -->

            <!-- <div class="item-title">Raio da Bucha</div> -->
            <div>
              {{
                dataMoldeFechado.RAIO_MOLDE === "angulo" ? "Ângulo 45°" : "Raio"
              }}
            </div>
          </div>
        </div>

        <div class="items">
          <div class="mini-20 bd-right">
            <div class="item-title">Tipo de Molde</div>
            <p>{{ dataMoldeFechado.TIPO_DE_MOLDE }} Placas</p>
          </div>

          <div class="mini-20">
            <div class="item-title">Sistema de Extração</div>
            <div class="items" style="gap: 5px">
              <h5
                v-if="
                  dataMoldeFechado.SISTEMA_DE_EXTRACAO_HID == 'false' &&
                  dataMoldeFechado.SISTEMA_DE_EXTRACAO_PNE == 'false' &&
                  dataMoldeFechado.SISTEMA_DE_EXTRACAO_MEC == 'false'
                "
              >
                N/A
              </h5>

              <h5 v-if="dataMoldeFechado.SISTEMA_DE_EXTRACAO_HID == 'true'">
                Hidráulico
              </h5>

              <h5 v-if="dataMoldeFechado.SISTEMA_DE_EXTRACAO_PNE == 'true'">
                Pneumatico
              </h5>

              <h5 v-if="dataMoldeFechado.SISTEMA_DE_EXTRACAO_MEC == 'true'">
                Mécanico
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="items">
        <div class="items-columm bd-right">
          <div>
            <div class="item-title bd-top bd-bottom">Extração</div>
          </div>
          <div class="items-row">
            <div>
              <div class="item-title">Curso Extrator(mm)</div>
              <!-- <div class="item-title">Layout de Extração</div> -->
              <!-- <div class="item-title">Distania entre futos(mm)</div> -->
              <!-- <div class="item-title">Diâmetro(mm)</div> -->
            </div>

            <div class="boxContainer">
              <div>{{ dataMoldeFechado.CURSOR_EXTRATOR }}</div>
              <!-- <div>{{ dataMoldeFechado[0].DESC_LAYOUT }}</div> -->
              <!-- <div>{{ dataMoldeFechado[0].DIST_FUROS }}</div> -->
              <!-- <div>{{ dataMoldeFechado[0].DIAMETRO }}</div> -->
            </div>

            <!-- <div>
              <img
                :src="
                  this.$store.state.ImgURL +
                  'layout_extracao/' +
                  dataMoldeFechado.PATH_LAYOUT +
                  '.webp'
                "
                width="55"
                height="55"
              />
            </div> -->
          </div>
        </div>

        <div class="bd-top">
          <div class="item-title bd-bottom">Refrigeração (Quantidade)</div>
          <div class="row">
            <div class="item-title">x</div>
            <div class="item-title">Entrada / Saida</div>
            <!-- <div class="item-title">Saida</div> -->
          </div>

          <div class="row">
            <div class="item-title">L. Móvel</div>
            <div>{{ dataMoldeFechado.REFRIGERACAO }}</div>
            <!-- <div>0</div> -->
          </div>

          <div class="row">
            <div class="item-title">L. Fixo</div>
            <div>{{ dataMoldeFechado.LADO_FIXO }}</div>
            <!-- <div>0</div> -->
          </div>

          <div class="row">
            <div class="item-title">Gaveta(s)</div>
            <div>{{ dataMoldeFechado.GAVETAS }}</div>
            <!-- <div>0</div> -->
          </div>
        </div>
      </div>

      <div class="sub-categorias bd-bottom bd-top">Câmara Quente</div>
      <div class="items">
        <div class="items-row-camera-quente bd-right">
          <div class="item-title">ID</div>
          <div class="padd">
            {{ dataMoldeFechado.CQ_ID || "Não Aplicável" }}
          </div>
        </div>

        <div class="items-row-camera-quente bd-right">
          <div class="item-title">Nº de Zonas</div>
          <div>{{ dataMoldeFechado.CQ_N_ZONAS || "Não Aplicável" }}</div>
        </div>

        <div class="items-row-camera-quente bd-right">
          <div class="item-title">Fabricante</div>
          <div>{{ dataMoldeFechado.CQ_FABRICANTE || "Não Aplicável" }}</div>
        </div>

        <div class="items-row-camera-quente">
          <div class="item-title">Tipo de termopar</div>
          <div>
            {{ dataMoldeFechado.CQ_TIPO_TERMOPAR || "Não Aplicável" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataMoldeFechado: "",
  },
};
</script>

<style scoped>
.boxContainer {
  /* height: 7rem; */
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.items-row-camera-quente {
  width: 100%;
  height: 16%;
  background: var(--white);
  font-size: 12px;
  align-items: center;
  justify-content: center;
}
</style>
